import { OrganizationUsersGroup } from ".";

export default class OrganizationMembersGroup extends OrganizationUsersGroup {
  type = "OrganizationMembersGroup";

  hiddenMembers?: boolean;
}
